<template>
    <div class="welcome__main">
        <div class="welcome__title">
            {{ title }} 
        </div>
        <div class="welcome__steps">
            <div class="welcome__step">
                <span class="welcome__label">1.</span>
                <span>
                    {{ stepFirst }} 
                </span>
            </div>
            <div class="welcome__step">
                <span class="welcome__label">2.</span>
                <span>
                    {{ stepSecond }} 
                </span>
            </div>
            <div class="welcome__step">
                <span class="welcome__label">3.</span>
                <span>
                    {{ stepThird }} 
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { Strings } from "@/locales/types/enums/strings";
    import { useI18n } from "vue-i18n";

    const { t } = useI18n();
    const title: string = t(Strings.LOGIN_WELCOME_SECOND_TITLE).toString();
    const stepFirst: string = t(Strings.LOGIN_WELCOME_SECOND_STEP_FIRST).toString();
    const stepSecond: string = t(Strings.LOGIN_WELCOME_SECOND_STEP_SECOND).toString();
    const stepThird: string = t(Strings.LOGIN_WELCOME_SECOND_STEP_THIRD).toString();
</script>
